import { render, staticRenderFns } from "./propertyDialog.vue?vue&type=template&id=2d2a4b10&scoped=true&"
import script from "./propertyDialog.vue?vue&type=script&lang=js&"
export * from "./propertyDialog.vue?vue&type=script&lang=js&"
import style0 from "./propertyDialog.vue?vue&type=style&index=0&id=2d2a4b10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2a4b10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCardText,VTab,VTabItem,VTabs,VTabsItems})
